import Vue from 'vue'
import App from './app'
import router from '@router'
import appStore from '@/src/state/appStore'
import '@components/_globals'
import VueI18n from 'vue-i18n'
import BootstrapVue from 'bootstrap-vue'
import VueDataTables from 'vue-data-tables'
import Bars from 'vuebars'
import firebase from 'firebase/app'
import 'firebase/auth'
import VueApexCharts from 'vue-apexcharts'
import axios from 'axios';

axios.defaults.baseURL = process.env.NODE_ENV === 'dev' ? 'http://localhost:3005' : 'https://dash-api.vikingo.org';
// Don't warn about using the dev version of Vue in development.
Vue.config.productionTip = process.env.NODE_ENV === 'production'

Vue.use(BootstrapVue)
Vue.use(VueI18n)
Vue.use(VueDataTables)
Vue.use(Bars)
Vue.use(VueApexCharts)

const fireConf = {
  apiKey: 'AIzaSyBUa7F_0ZY55Q123fSjAHAeOvp_nRKcbDo',
  authDomain: 'vikingo-cloud.firebaseapp.com',
  databaseURL: 'https://vikingo-cloud.firebaseio.com',
  projectId: 'vikingo-cloud',
  storageBucket: 'vikingo-cloud.appspot.com',
  messagingSenderId: '190440625825',
  appId: '1:190440625825:web:a3806a79fb320cc8f282e0',
}
firebase.initializeApp(fireConf)

window.onerror = function myErrorHandler(errorMsg, url, lineNumber) {
  alert(errorMsg, url, lineNumber)
  return false
}

const ru_messages = require('./lang/ru.json')
const en_messages = require('./lang/en.json')
const messages = {
  en: en_messages,
  ru: ru_messages,
}

let lang = 'en'
if (localStorage.getItem('lang')) {
  lang = localStorage.getItem('lang')
}
const i18n = new VueI18n({
  locale: lang, // set locale
  messages, // set locale messages
})

let app
firebase.auth().onAuthStateChanged((user) => {
  if (!app) {
    app = new Vue({
      i18n,
      router,
      appStore,
      render: (h) => h(App),
    }).$mount('#app')
  }
})

// If running e2e tests...
if (process.env.VUE_APP_TEST === 'e2e') {
  // Attach the app to the window, which can be useful
  // for manually setting state in Cypress commands
  // such as `cy.logIn()`.
  window.__app__ = app
}
